import api from './config';

/**
 * 获取设备留言板列表
 * @param {Object} params 查询参数
 */
export function getDeviceBoards(params = {}) {
  return api.get('/device_board', { params });
}

/**
 * 获取设备角色配置记录详情
 * @param {string} id 设备角色配置记录ID
 */
export function getDeviceBoardById(id) {
  return api.get(`/device_board/${id}`);
}
